import * as React from 'react';
import TestGuideTooltip from './testGuideTooltip';
import { PaccApplyResultVO } from '@domain/vo/phs/pacc/results/PaccApplyResultVO';
import { ModuleType, moduleTypeNameMap, moduleTypeStringMap } from '@domain/constant/moduleType';
import classNames from 'classnames/bind';
import styles from './testGuideHeader.module.scss';

const cx = classNames.bind(styles);

interface TestGuideHeaderProps {
  moduleType: ModuleType;
  applyResult: PaccApplyResultVO;
}

const TestGuideHeader = ({ moduleType, applyResult }: TestGuideHeaderProps) => {
  if (!applyResult) return null;

  const moduleResult = applyResult.moduleResults?.find((moduleResult) => moduleResult.module === moduleType);
  const unreliableYn = moduleResult?.unreliableYn;
  const status = unreliableYn ? 'warning' : 'good';
  const statusTitle = unreliableYn ? (
    <>
      보완점을
      <br />
      확인해 보세요!
    </>
  ) : (
    <>
      안정적으로
      <br />
      응시했어요!
    </>
  );
  const statusSubTitle = unreliableYn
    ? '응시 가이드와 안내 표시를 확인해 주세요.'
    : '아래의 개별 피드백도 꼭 확인해 보세요.';

  return (
    <div className={cx('testGuideHeader', moduleTypeStringMap[moduleType])}>
      <strong className={cx('title')}>
        {applyResult.userName}님의
        <br />
        <span className={cx('emphasis')}>{moduleTypeNameMap[moduleType]}</span> 응시 결과
        <TestGuideTooltip />
      </strong>

      <div className={cx('statusArea')}>
        <strong className={cx('title', status)}>{statusTitle}</strong>
        <p className={cx('notice')}>{statusSubTitle}</p>
      </div>
    </div>
  );
};

export default TestGuideHeader;
